import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Navbar";

export default function Register() {
  const { register, apiError } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      // If coming from a project preview, claim it (may hit plan limit).
      const m = next.match(/\/editor\/([^/]+)/);
      if (m) {
        try {
          await api.post(`/projects/${m[1]}/claim`);
        } catch (err) {
          toast.error(apiError(err));
          nav("/pricing");
          return;
        }
      }
      toast.success("Account created!");
      nav(next);
    } catch (err) { toast.error(apiError(err)); setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          <Logo />
          <h1 className="font-heading font-bold text-3xl tracking-tight text-[#09090b] mt-10">Save your project</h1>
          <p className="font-body text-sm text-[#52525b] mt-2">Create a free account to edit and publish your website.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="ml-label">Name</label>
              <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)}
                className="w-full mt-2 border border-border rounded-xl px-4 py-3 font-body text-sm outline-none focus:ring-2 focus:ring-sky-400" />
            </div>
            <div>
              <label className="ml-label">Email</label>
              <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-2 border border-border rounded-xl px-4 py-3 font-body text-sm outline-none focus:ring-2 focus:ring-sky-400" />
            </div>
            <div>
              <label className="ml-label">Password</label>
              <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-2 border border-border rounded-xl px-4 py-3 font-body text-sm outline-none focus:ring-2 focus:ring-sky-400" />
            </div>
            <button data-testid="register-submit" disabled={loading} className="w-full ml-ai-btn rounded-full py-3 font-semibold text-sm font-body inline-flex items-center justify-center gap-2">
              {loading && <Loader2 size={16} className="animate-spin" />} Create free account
            </button>
          </form>
          <p className="font-body text-sm text-[#52525b] mt-6">Already have an account? <Link to="/login" className="font-semibold text-[#09090b]" data-testid="to-login">Log in</Link></p>
        </div>
      </div>
      <div className="hidden lg:block bg-[#09090b] ml-grid-bg" />
    </div>
  );
}
